<template>
  <app-base-main :baseStyle="{height: '100%', boxSizing: 'border-box', background: 'none', paddingTop: '12px'}" :contentStyle="{height: '100%'}">
    <template #base-content >
      <app-left-right-stow show-stow-button @change="stowChange">
        <template #left>
          <app-sb-ad-tree
            ref="sbAdTree"
            :init-market-id="marketId"
            @market-change="marketChange($event)"
            @portfolio-change="portfolioChange($event)"
            @getLocal="getLocal"
            @goHome="goHome">
          </app-sb-ad-tree>
        </template>
        <template #right>
          <div class="ad-tree__market" v-show="!isStow">
            <gj-market-select
                init-value
                width="200px"
                :value="marketId"
                :clearable="false"
                @input="rightMarketChange($event)"
            ></gj-market-select>
            <div class="ad-tree--time">
              <gj-local-time :label="localCountry" :time="localTime"></gj-local-time>
            </div>
          </div>
          <div v-if="[-1, 0].includes(adStore.SB.isBrand)" class="no-auth-wrapper">
            <div class="no-auth-content" v-loading="adStore.SB.isBrand == -1">
              <div class="no-auth-empty">
                <gj-empty text="此店铺无品牌，赶紧去亚马逊后台进行品牌备案吧～"></gj-empty>
              </div>
            </div>
          </div>
          <div v-else-if="adStore.SB.isAdsAuth" class="right-content">
            <app-sb-ad-navigator></app-sb-ad-navigator>
            <template v-if="showAdManager">
              <app-sb-ad-manager
                  ref="adSpManager"
                  :init-date="adStore.SB.campaignDate"
                  :market-id="marketId"
                  :portfolio-id="portfolioId"
                  :active-tab="activeTab"
              ></app-sb-ad-manager>
            </template>
            <template v-else-if="showCampaignManager">
              <app-sb-ad-campaign-manager
                  :init-date="adStore.SB.campaignDate"
                  :market-id="marketId"
                  :portfolio-id="portfolioId"
                  :campaign-id="adStore.SB.campaign.campaignId || adStore.SB.campaign.draftsCampaignId"
                  :active-tab="activeTab"
              ></app-sb-ad-campaign-manager>
            </template>
          </div>
          <div v-else class="no-auth-wrapper">
            <div class="no-auth-empty">
              <gj-empty text="未进行广告授权，请先授权"></gj-empty>
              <gj-button
                  type="primary"
                  @click="$router.push('/system/market')">
                广告授权
              </gj-button>
            </div>
          </div>
        </template>
      </app-left-right-stow>
    </template>
  </app-base-main>
</template>

<script>
import AppSbAdTree from "./ad-tree/ad-tree";
import { adStore } from "modules/ad/common/store";
import AppSbAdNavigator from "./common/components/ad-navigator";
import AppSbAdManager from "./ad-manager/ad-manager";
import AppSbAdCampaignManager from "./ad-campaign-manager/ad-campaign-manager";
import {defaultVal, isMeaningful, isMeaningless} from "../../../../utils/common";
import { getBrandAdvertisingCornerMark } from '@/api/ad.js'
import {AdDefaultBid} from "@/views/modules/ad/common/enum";
import {mapGetters} from "vuex";

export default {
  name: "app-sb-ad",
  components: {AppSbAdCampaignManager, AppSbAdManager, AppSbAdNavigator, AppSbAdTree},
  created() {
    if (isMeaningful(this.$route.query.marketId)) {
      this.marketId = this.$route.query.marketId;
    }
    if (isMeaningful(this.$route.query.campaignId)) {
      this.adStore.SB.campaign = {
        campaignId: this.$route.query.campaignId,
        campaignName: this.$route.query.campaignName,
      };
    }
    this.activeTab = defaultVal(this.$route.query.activeTab, null);
  },
  mounted() {
    adStore.SB.rootMountEl = this.$el;
  },
  data() {
    return {
      adStore,
      marketId: null,
      portfolioId: null,
      activeTab: null,
      localCountry: null,
      localTime: null,
      isStow: true,
      cornerMarker: {}, // 角标对象
    }
  },
  provide() {
    return {
      getBrandAdvertisingCornerMark: this.getBrandAdvertisingCornerMark,
      cornerMarkerMap: () => this.cornerMarker,
      treeMarketChange: (marketId) => {
        this.$refs.sbAdTree.marketChange(marketId)
      },
    }
  },
  computed: {
    ...mapGetters({
      markets: 'authMarkets'
    }),
    showAdManager() {
      return isMeaningless(this.adStore.SB.campaign) && isMeaningless(this.adStore.SB.group);
    },
    showCampaignManager() {
      return isMeaningful(this.adStore.SB.campaign) && isMeaningless(this.adStore.SB.group);
    },
  },
  methods: {
    // 回到首页
    goHome() {
      this.$refs.adSpManager && (this.$refs.adSpManager.activeTabMap = "adCampaign")
    },
    // 获取角标
    async getBrandAdvertisingCornerMark() {
      let params = { 
        marketId: this.marketId,
        campaignId: this.adStore.SB.campaign && (this.adStore.SB.campaign.campaignId || this.adStore.SB.campaign.draftsCampaignId),
        adsType: 1
      }
      let { data } = await getBrandAdvertisingCornerMark(params)
      this.cornerMarker = data
    },
    marketChange(marketId) {
      if (this.marketId !== marketId) {
        this.adStore.SB.defaultBid = AdDefaultBid[this.markets.find(r => r.id === marketId).countryCode]?.SBDefaultBid || null;
        this.marketId = marketId;
        this.adStore.SB.campaign = null;
        this.adStore.SB.group = null;
      }
    },
    portfolioChange(portfolioId) {
      if (this.portfolioId !== portfolioId) {
        this.portfolioId = portfolioId;
        this.adStore.SB.campaign = null;
        this.adStore.SB.group = null;
      }
    },
    // 左侧店铺修改
    rightMarketChange(marketId) {
      this.$refs.sbAdTree.marketChange(marketId)
    },
    // 获取站点事件名称
    getLocal(localTime, localCountry) {
      this.localTime = localTime
      this.localCountry = localCountry
    },
    // 左右结构展开收起
    stowChange(type) {
      this.isStow = type
      // this.$store.dispatch("ad/setTableHeight")
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../common/no-auth";
  /deep/ .right-container{
    display: flex;
    flex-direction: column;
  }
  .no-auth-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .right-content {
    height: 0;
    flex: 1;
    padding: 0 16px 16px 16px;
    background: #fff;
    box-sizing: border-box;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.15);
    display: flex;
    flex-direction: column;
    /deep/.ad-tabs {
      height: 0;
      flex: 1;
    }
  }
  .ad-tree__market {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 16px 16px 0;
    /deep/.el-input__inner {
      background: #F6F8FB;
      border: 0;
      &:focus{
        box-shadow: none;
      }
    }
    .ad-tree--time {
      padding-left: 16px;
      /deep/.gj-local-time {
        color: #999;
      }
    }
  }
</style>
